import { filterPatientsForPetRecord, formatPatientSearchToPatientRecord } from '@app/shared/utils/static-helpers/pet-record-helper';
import { createSelector } from '@ngrx/store';
import { AppState } from '..';

const patientState = (state: AppState) => state.patient;

/**
 * patients selectors
 */
const selectPatients = createSelector(patientState, (state) => state.patients);

export const selectPatientsLoaded = createSelector(patientState, (state) => state.patientsLoaded);

export const selectPatientsLoading = createSelector(patientState, (state) => state.patientsLoading);

/**
 * get each patient with a label to display in autocomplete options
 * used in the home page and in the identification component in pet details page
 */
export const selectPatientsAutocomplete = createSelector(selectPatients, (patients) =>
  Object.values(patients).map((patient) => {
    const ownerName = patient.owner ? `${patient.owner.givenName} ${patient.owner.familyName}` : null;
    return {
      label: ownerName ? `${patient.pet.name} - ${ownerName}` : patient.pet.name,
      value: patient,
    };
  }),
);

/**
 * get each patient formatted for the pet record page
 */
export const selectPatientsPetRecord = createSelector(selectPatients, (patients) => {
  return Object.values(patients)
    .filter((patient) => filterPatientsForPetRecord(patient))
    .map((patient) => {
      return formatPatientSearchToPatientRecord(patient);
    });
});

export const selectPatientStateError = createSelector(patientState, (state) => state.error);
